jQuery( function( $ ) {
	$( document ).ready( function() {

		cookiesJS = ( function() {

			var
				_bar = $( '.cookie-bar' ),

				init = function() {
					if ( 0 !== _bar.length ) {
						_bar.alert();
						_bar.find( '.close' ).click( function() {
							_dismissCookieBar( _bar );

						});
					}
				},

				_dismissCookieBar = function( _bar ) {
					$.ajax({
						url: wps.ajax,
						type: 'POST',
						data: {
							action: 'dismiss_cookie_bar'
						}
					}).done( function() {
						_bar.alert( 'close' );
					}).fail( function( response ) {
						console.log( response );
					});
				}
			;

			return {
				init: init
			};

		}() );

	});
});
